import { render, staticRenderFns } from "./PAYGChangePlanSettings.vue?vue&type=template&id=f590c8f2&"
import script from "./PAYGChangePlanSettings.vue?vue&type=script&lang=js&"
export * from "./PAYGChangePlanSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports